export default "__VITE_ASSET__ee5bebd0__"